import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLinkedin, faYoutube } from '@fortawesome/free-brands-svg-icons'
import Social, { SocialLink } from '@ui/social'

const socialIcons = {
  linkedin: faLinkedin,
  youtube: faYoutube
}

const SocialIcons = ({
  socials,
  size = 'medium',
  shape = 'rounded',
  variant = 'outlined',
  tooltip = true,
  tooltip_position = 'top',
  ...restProps
}) => {
  return (
    <Social
      size={size}
      shape={shape}
      tooltip={tooltip}
      tooltip_position={tooltip_position}
      variant={variant}
      {...restProps}
    >
      {socials?.map((social) => {
        const socialIcon = socialIcons[social.title?.toLowerCase()]
        if (!socialIcon) return null
        return (
          <SocialLink
            key={social.id}
            path={social.link}
            title={social.title}
            aria-label={social.title}
          >
            <FontAwesomeIcon icon={socialIcon} />
          </SocialLink>
        )
      })}
    </Social>
  )
}

export default SocialIcons
